import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './ThreadPostbox';
import { getThreadState } from '../../selectors';
import { threadUpdated } from '../../actionCreators';
import { getCurrentUser } from '../../../publicSession/selectors';

export type StateProps = Pick<
  Props,
  'streamId' | 'currentUser' | 'canPostComment'
>;
export type DispatchProps = Pick<Props, 'onThreadUpdated'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (
  state,
  { commentableItemId, commentableTypeId, parentId }
) => {
  const { streamId, canPostComment } = getThreadState(
    state,
    commentableTypeId,
    commentableItemId,
    parentId
  );

  return {
    streamId,
    currentUser: getCurrentUser(state),
    canPostComment,
  };
};
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onThreadUpdated: threadUpdated,
};

export default connect(mapStateToProps, mapDispatchToProps);
